import * as React from 'react';
import Icons from '../icons';

export default class Emptyparties extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="emptyScreen">
                <Icons name="Emptyparty" className="" /> <br />   
                <h2>No parties found</h2>
                <p>Parties related to the {this.props.type} would be displayed here.</p>
            </div>
        );
    }
}